import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../../widgets/layout/CardUI'
import ButtonTinyWithSpinnerUI from '../../../../widgets/action/ButtonTinyWithSpinnerUI'
import LastRepaymentScheduleModalSF from './LastRepaymentScheduleModalSF'
import RepaymentRemarksModalSF from './RepaymentRemarksModalSF'
import RepaymentDefaultsModalSF from './RepaymentDefaultsModalSF'
import RepaymentBalanceModalSF from './RepaymentBalanceModalSF'
import ButtonTinyUI from '../../../../widgets/action/ButtonTinyUI'
import LabelAndValueUI from '../../../../widgets/layout/LabelAndValueUI'
import RepaymentOpExpensesModalSF from './RepaymentOpExpensesModalSF'
import RepaymentChargeAmountModalSF from './RepaymentChargeAmountModalSF.js'
import PenaltyModalSF from './PenaltyModalSF'
import './RepaymentList.css'
import RepaymentInterestModalSF from './RepaymentInterestModalSF'
import RepaymentPrincipalModalSF from './RepaymentPrincipalModalSF'

const RepaymentListUI = ({ context, loan, totals, repaymentList,
  onRefreshClick, chargeAmountsList,account,
  updateRemarksMode, onUpdateRemarksClick, onCancelRemarksClick, selectedRepayment,
  updateOpExpensesMode, onUpdateOpExpensesClick, onCancelOpExpensesClick,
  addChargeAmountMode, onAddChargeAmountClick, onCancelChargeAmountClick,
  updateDefaultsMode, onUpdateDefaultsClick, onCancelDefaultsClick,
  updateInterestMode, onUpdateInterestClick, onCancelInterestClick,
  updatePrincipalMode, onUpdatePrincipalClick, onCancelPrincipalClick,
  onDownloadPenalChargeClick, downloadPenalChargeSubmitted,
  updateBalanceMode, onUpdateBalanceClick, onCancelBalanceClick,
  onEmiPaymentClick, emiPaymentSubmitted, emiPaymentErrorList, selectedScheduledDate,
  onPenaltyClick, penaltySubmitted, onPenaltyCancelClick,
  onPayClick, paymentSubmitted, onPayCancelClick,
  addRowMode, onAddRowClick, onAddRowCancel, details, onDetailsClick
}) =>
  <div className='su_rplst'>
    <span className='g_flex_h'>
      <Link to='#' onClick={onDetailsClick} >Details</Link>
    </span>
    {
      repaymentList &&
      <CardUI className='g_m_top_50'>
        <table className='sched'>
          <thead className='g_sticky'>
            <tr className='head'>
              <td></td>
              <td className='g_text_center'>Scheduled</td>
              <td className='g_text_center'>DSRA Dip Int<br />(Legacy)</td>
              <td className='g_text_center'>Penal Charge<br />(Legacy)</td>
              <td className='g_text_center'>Penal Charge</td>
              <td className='g_text_center'>Penal Paid</td>
              <td className='g_text_center'>Interest</td>
              <td className='g_text_center'>Int Paid</td>
              <td className='g_text_center'>Principal</td>
              <td className='g_text_center'>Pr Paid</td>
              {
                repaymentList.length > 0 && repaymentList[0].emiTaxList.length > 0 &&
                <td className='g_text_center g_m_left_50'>EMI Tax</td>
              }
              <td className='g_text_center'>EMI</td>
              <td className='g_text_center'>EMI Paid</td>

              <td className='g_text_center'>Closing Balance</td>
            </tr>
          </thead>
          <tbody>
            {
              repaymentList.map((repayment, i) =>
                <React.Fragment key={i}>
                  <tr>
                    <td>{i + 1}</td>
                    <td className='g_text_right'>
                      <span className='g_no_wrap_2'>{repayment.scheduledDateF1}</span><br />
                      {
                        repayment.daysPastDue &&
                        <span className='g_text_right g_muted'>DPD: {repayment.daysPastDue}</span>
                      }
                    </td>
                    {<DsraDipInterestUI repayment={repayment} />}
                    <PenalChargesUI repayment={repayment} onUpdateDefaultsClick={onUpdateDefaultsClick} details={details}
                      onDownloadPenalChargeClick={onDownloadPenalChargeClick} />
                    <ChargeUI chargeAmountsList={repayment.chargesAmountsList} chargeType="default_interest" />
                    <InterestUI repayment={repayment} onUpdateInterestClick={onUpdateInterestClick} details={details} />
                    <PrincipalUI repayment={repayment} onUpdatePrincipalClick={onUpdatePrincipalClick} details={details} />
                    {
                      repaymentList.length && repaymentList[0].emiTaxList.length > 0 &&
                      <td key={i} className='g_text_center'>
                        {
                          repayment.emiTaxList.map((tax, j) =>
                            <span key={j}>
                              {j != 0 && <>+</>}
                              {tax.amountF5}
                            </span>
                          )
                        }
                      </td>
                    }
                    <EMIUI repayment={repayment} />
                    <td className='g_text_right'>
                      {
                        (!repayment.balanceAdjustedF5 || repayment.balanceF5 === repayment.balanceAdjustedF5) &&
                        <>{repayment.balanceF5}</>
                      }
                      {
                        repayment.balanceAdjustedF5 && repayment.balanceF5 !== repayment.balanceAdjustedF5 &&
                        <span className='g_flex_v'>
                          {repayment.balanceAdjustedF5}
                          <LabelAndValueUI label='Original' className='g_tiny'>{repayment.balanceF5}</LabelAndValueUI>
                        </span>
                      }
                    </td>
                    {
                      details &&
                      <td className='g_text_right'>
                        <span className='icon icon-pencil g_m_left_50 g_cursor_pointer g_muted' onClick={onUpdateRemarksClick}
                          data-scheduled-date={repayment.scheduledDate}>
                        </span>
                        <Link to='#' onClick={onUpdateBalanceClick} data-scheduled-dateISO={repayment.scheduledDateISO}>Update Balance</Link>
                      </td>
                    }
                    {
                      context.permissions.includes('su_superuser_business') &&
                      (repayment.status === 'unpaid' || repayment.defaultInterestStatus === 'unpaid') &&
                      <td>
                        {/* {
                          repayment.status === 'unpaid' &&
                          <ButtonTinyWithSpinnerUI to='#' label='Pay'
                            onClick={onEmiPaymentClick}
                            busy={emiPaymentSubmitted && repayment.scheduledDate == selectedScheduledDate}
                            errorList={emiPaymentErrorList && repayment.scheduledDate == selectedScheduledDate}
                            alignLeft={true}
                            rowId={repayment.scheduledDate}
                          />
                        } */}
                        {
                          repayment.defaultInterestStatus === 'unpaid' &&
                          <ButtonTinyUI className='g_m_top_25'
                            label='Penalty'
                            onClick={onPenaltyClick}
                            rowId={repayment.scheduledDate}
                          />
                        }
                      </td>
                    }
                  </tr>

                  {
                    repayment.remarks && details &&
                    <tr>
                      <td colSpan='16' className='g_muted g_tiny'>Internal remarks: {repayment.remarks}</td>
                    </tr>
                  }
                  {
                    repayment.oopExpenseRemarks && details &&
                    <tr>
                      <td colSpan='16' className='g_muted g_tiny'>OOP expense remarks: {repayment.oopExpenseRemarks}</td>
                    </tr>
                  }
                  {
                    repayment.balanceAdjustedFormula && details &&
                    <tr>
                      <td colSpan='16' className='g_muted g_tiny'>Balance calc: {repayment.balanceAdjustedFormula}</td>
                    </tr>
                  }
                  {
                    repayment.dsraHistoryList && repayment.dsraHistoryList.length > 0 && details &&
                    <tr>
                      <td colSpan='16' className='g_muted g_tiny'>
                        {
                          repayment.dsraHistoryList.map((d, i) =>
                            <span key={i} className='g_flex_v'>
                              DSRA {d.status}: {d.dateF1}, amount: {d.dsraAmountF5} current: {d.dsraCurrentF5}
                            </span>
                          )
                        }
                      </td>
                    </tr>
                  }
                  {
                    repayment.dsraDipInterestFormula && details &&
                    <tr>
                      <td colSpan='16' className='g_muted g_tiny'>
                        DSRA Int: {repayment.dsraDipInterestFormula.replace('(waived)', '')}
                        {
                          repayment.dsraDipInterestFormula.includes('(waived)') &&
                          <span className='g_muted'><b>(waived)</b></span>
                        }
                      </td>
                    </tr>
                  }
                  {
                    repayment.defaultHistoryList && repayment.defaultHistoryList.length > 0 && details &&
                    <tr>
                      <td colSpan='16' className='g_muted g_tiny'>
                        {
                          repayment.defaultHistoryList.map((d, i) =>
                            <span key={i} className='g_flex_v'>
                              Default date: {d.defaultDateF1}, cure date: {d.cureDateF1}, on o/s balance: {d.balanceF4}
                              <span className='g_muted'>Default reason: {d.defaultReason}</span>
                            </span>
                          )
                        }
                      </td>
                    </tr>
                  }
                  {
                    repayment.defaultInterestFormula && details &&
                    <tr>
                      <td colSpan='16' className='g_muted g_tiny'>Default Int: {repayment.defaultInterestFormula}</td>
                    </tr>
                  }
                  {
                    repayment.oopExpenseInterestFormula && details &&
                    <tr>
                      <td colSpan='16' className='g_muted g_tiny'>OOP Expense Interest: {repayment.oopExpenseInterestFormula}</td>
                    </tr>
                  }
                </React.Fragment>
              )
            }
          
            <tr className='head'>
              <td className='g_text_center'></td>
              <td className='g_text_center'>Totals</td>
              <TotalAndPaidUI total={totals.totalDsraDipInterestF5} paid={totals.totalDsraDipInterestPaidF5} />
              <td className='g_text_center'>{totals.totalDefaultInterestF5}</td>
              <td className='g_text_center'>{totals.totalDefaultInterestPaidF5}</td>
              <td></td>
              <td className='g_text_center'>{totals.totalInterestF5}</td>
              <td className='g_text_center'>{totals.totalInterestPaidF5}</td>
              <td className='g_text_center'>{totals.totalPrincipalF5}</td>
              <td className='g_text_center'>{totals.totalPrincipalPaidF5}</td>
              {
                repaymentList.length > 0 && repaymentList[0].emiTaxList.length > 0 &&
                <td className='g_text_center g_m_left_50'></td>
              }
              <td className='g_text_center'>{totals.totalEMIF5}</td>
              <td className='g_text_center'></td>

              <td className='g_text_center'></td>
            </tr>
          </tbody>
        </table>
        {
          context && context.permissions.includes('su_superuser') &&
          <Link to='#' className='g_no_wrap_2 g_small' onClick={onAddRowClick}>Add Row</Link>
        }
      </CardUI>
    }

    {/* added noBusy */}
    <RepaymentRemarksModalSF context={context} loan={loan}
      updateMode={updateRemarksMode} onCancelClick={onCancelRemarksClick}
      onRefreshClick={onRefreshClick} selectedRepayment={selectedRepayment}
    />

    {/* added noBusy */}
    <RepaymentOpExpensesModalSF context={context} loan={loan}
      updateMode={updateOpExpensesMode} onCancelClick={onCancelOpExpensesClick}
      onRefreshClick={onRefreshClick} selectedRepayment={selectedRepayment}
    />

    {/* added noBusy */}
    <RepaymentChargeAmountModalSF context={context} loan={loan}
      updateMode={addChargeAmountMode} onCancelClick={onCancelChargeAmountClick}
      onRefreshClick={onRefreshClick} selectedRepayment={selectedRepayment}
    />

    {/* added noBusy */}
    <RepaymentDefaultsModalSF context={context} loan={loan}
      updateMode={updateDefaultsMode} onCancelClick={onCancelDefaultsClick}
      onRefreshClick={onRefreshClick} selectedRepayment={selectedRepayment}
    />

    {/* added noBusy */}
    <RepaymentInterestModalSF context={context} loan={loan}
      updateMode={updateInterestMode} onCancelClick={onCancelInterestClick}
      onRefreshClick={onRefreshClick} selectedRepayment={selectedRepayment}
    />

    {/* added noBusy */}
    <RepaymentPrincipalModalSF context={context} loan={loan}
      updateMode={updatePrincipalMode} onCancelClick={onCancelPrincipalClick}
      onRefreshClick={onRefreshClick} selectedRepayment={selectedRepayment}
    />

    {/* added noBusy */}
    <RepaymentBalanceModalSF context={context} loan={loan}
      updateMode={updateBalanceMode} onCancelClick={onCancelBalanceClick}
      onRefreshClick={onRefreshClick} selectedRepayment={selectedRepayment}
    />

    <PenaltyModalSF
      context={context} loan={loan} onRefreshClick={onRefreshClick}
      updateMode={penaltySubmitted} onCancelClick={onPenaltyCancelClick}
      selectedScheduledDate={selectedScheduledDate}
    />

    <LastRepaymentScheduleModalSF
      context={context} loan={loan}
      createMode={addRowMode} onCancelClick={onAddRowCancel}
      onRefreshClick={onRefreshClick}
    />
  </div>

const TotalAndPaidUI = ({ total, paid }) =>
  <td className='g_text_right'>
    <span className='g_flex_v'>
      {total}
      {
        paid &&
        <>
          <span className='g_muted g_tiny g_m_top_50'>Collected</span>
          <span>{paid}</span>
        </>
      }
    </span>
  </td>

const ValueStatusUI = ({ value, value2, status }) =>
  <td className='g_text_right'>
    <span className='g_flex_v'>
      {value}
      {
        value2 &&
        <span className='g_muted g_tiny g_no_wrap_2'>{value2}</span>
      }
      {status === 'paid' && <span className='g_tiny g_muted'>paid</span>}
    </span>
  </td>

const EMIUI = ({ repayment }) =>
  <>
    <td className='g_text_right'>
      <span className='g_flex_v'>
        {repayment.emiF5}
        {
          repayment.emiInitiatedDateF1 &&
          <LabelAndValueUI label='Initiated' className='g_tiny'>{repayment.emiInitiatedDateF1}</LabelAndValueUI>
        }
        <span className='g_tiny'><i>{repayment.status}</i></span>
      </span>
    </td>
    <td className='g_text_right'>
      <span className='g_flex_v'>
        {
          repayment.paymentDateF1 &&
          <span>{repayment.emiF5}</span>
        }
        {
          repayment.paymentDateF1 &&
          <LabelAndValueUI label='Paid' className='g_tiny'>{repayment.paymentDateF1}</LabelAndValueUI>
        }
      </span>
    </td>
  </>

const InterestUI = ({ repayment, onUpdateInterestClick, details }) =>
  <>
    <td className='g_text_right'>
      <span className='g_flex_v'>
        {
          repayment.interestAdjustedF5 &&
          <span>{repayment.interestAdjustedF5}</span>
        }
        {
          repayment.interestAdjustedF5 && repayment.interestF5 &&
          <LabelAndValueUI label='Original' className='g_tiny'>{repayment.interestF5}</LabelAndValueUI>
        }
        {
          !repayment.interestAdjustedF5 && repayment.interestF5 &&
          <span>{repayment.interestF5}</span>
        }
        {
          repayment.interestInitiatedDateF1 &&
          <LabelAndValueUI label='Initiated' className='g_tiny'>{repayment.interestInitiatedDateF1}</LabelAndValueUI>
        }
      </span>
      {
        details &&
        <div>
          <span className='icon icon-pencil g_cursor_pointer g_muted' onClick={onUpdateInterestClick}
            data-scheduled-date={repayment.scheduledDate} />
        </div>
      }
    </td>
    <td className='g_text_right'>
      <span className='g_flex_v'>
        {
          repayment.interestPaidDateF1 && repayment.interestAdjustedF5 &&
          <span>{repayment.interestAdjustedF5}</span>
        }
        {
          repayment.interestPaidDateF1 && !repayment.interestAdjustedF5 && repayment.interestF5 &&
          <span>{repayment.interestF5}</span>
        }
        {
          repayment.interestPaidDateF1 &&
          <LabelAndValueUI label='Paid' className='g_tiny'>{repayment.interestPaidDateF1}</LabelAndValueUI>
        }
      </span>
    </td>
  </>

const PrincipalUI = ({ repayment, onUpdatePrincipalClick, details }) =>
  <>
    <td className='g_text_right'>
      <span className='g_flex_v'>
        {repayment.principalF5}
        {
          repayment.principalInitiatedDateF1 &&
          <LabelAndValueUI label='Initiated' className='g_tiny'>{repayment.principalInitiatedDateF1}</LabelAndValueUI>
        }
      </span>
      {
        details &&
        <div>
          <span className='icon icon-pencil g_cursor_pointer g_muted' onClick={onUpdatePrincipalClick}
            data-scheduled-date={repayment.scheduledDate} />
        </div>
      }
    </td>
    <td className='g_text_right'>
      <span className='g_flex_v'>
        {
          repayment.principalPaidDateF1 &&
          <span>{repayment.principalF5}</span>
        }
        {
          repayment.principalPaidDateF1 &&
          <LabelAndValueUI label='Paid' className='g_tiny'>{repayment.principalPaidDateF1}</LabelAndValueUI>
        }
      </span>
    </td>
  </>

const OOPExpensesUI = ({ repayment, onUpdateOpExpensesClick, details }) =>
  <React.Fragment>
    <td className='g_text_right'>
      <span className='g_flex_v'>
        {repayment.oopExpenseF5}
        {
          repayment.oopExpenseInitiatedDateF1 &&
          <LabelAndValueUI label='Initiated' className='g_tiny'>{repayment.oopExpenseInitiatedDateF1}</LabelAndValueUI>
        }
        {
          repayment.oopExpenseInterestF5 &&
          <LabelAndValueUI label='Interest'>{repayment.oopExpenseInterestF5}</LabelAndValueUI>
        }
        {
          repayment.oopExpenseInterestInitiatedDateF1 &&
          <LabelAndValueUI label='Initiated' className='g_tiny'>{repayment.oopExpenseInterestInitiatedDateF1}</LabelAndValueUI>
        }
      </span>
      {
        details &&
        <span className='icon icon-pencil g_m_left_50 g_cursor_pointer g_muted' onClick={onUpdateOpExpensesClick}
          data-scheduled-date={repayment.scheduledDate} />
      }
    </td>

    <td className='g_text_right'>
      <span className='g_flex_v'>
        {
          repayment.oopExpensePaidDateF1 &&
          <>
            <span>{repayment.oopExpenseF5}</span>
            <LabelAndValueUI label='Paid' className='g_tiny'>{repayment.oopExpensePaidDateF1}</LabelAndValueUI>
          </>
        }
        {
          repayment.oopExpenseInterestPaidDateF1 &&
          <>
            <span>{repayment.oopExpenseInterestF5}</span>
            <LabelAndValueUI label='Paid' className='g_tiny'>{repayment.oopExpenseInterestPaidDateF1}</LabelAndValueUI>
          </>
        }
      </span>
    </td>
  </React.Fragment>

const DsraDipInterestUI = ({ repayment }) =>
  <td className='g_text_right'>
    <span className='g_flex_v'>
      {repayment.drsaDipInterestF5}
      {
        repayment.dsraDipInterestInitiatedDateF1 &&
        <LabelAndValueUI label='Initiated' className='g_tiny'>{repayment.dsraDipInterestInitiatedDateF1}</LabelAndValueUI>
      }
      {
        repayment.dsraDipInterestWaived &&
        <span className='g_tiny'>waived</span>
      }
      {
        !repayment.dsraDipInterestWaived &&
        <span className='g_tiny'><i>{repayment.dsraDipInterestStatus}</i></span>
      }
      {
        repayment.dsraDipInterestPaidDateF1 &&
        <LabelAndValueUI label='Initiated' className='g_tiny'>{repayment.dsraDipInterestPaidDateF1}</LabelAndValueUI>
      }
    </span>
  </td>

const PenalChargesUI = ({ repayment, onUpdateDefaultsClick, details, onDownloadPenalChargeClick }) =>
  <React.Fragment>
    <td className='g_text_right'>
      <span className='g_flex_v'>
        {/* {repayment.defaultInterestPlusTaxF5} */}
        {
          repayment.defaultInterestF5 &&
          <span className='g_tiny'>{repayment.defaultInterestF5}</span>
        }
        {/* {
          repayment.defaultInterestTaxF5 &&
          <span className='g_tiny g_no_wrap_2'>GST: {repayment.defaultInterestTaxF5}</span>
        } */}
        {
          repayment.defaultInterestInitiatedDateF1 &&
          <LabelAndValueUI label='Initiated' className='g_tiny'>{repayment.defaultInterestInitiatedDateF1}</LabelAndValueUI>
        }
        <span className='g_tiny'><i>{repayment.defaultInterestStatus}</i></span>
        {/* {
          repayment.defaultInterestPaymentList &&
          repayment.defaultInterestPaymentList.map((pmnt, i) =>
            <span key={i} className='g_muted g_tiny g_no_wrap_2'>{pmnt.paymentAmountF5}<br />{pmnt.paymentDateF1}</span>
          )
        } */}
      </span>
      {
        details &&
        <div>
          <span className='icon icon-pencil g_cursor_pointer g_muted' onClick={onUpdateDefaultsClick}
            data-scheduled-date={repayment.scheduledDate} />
          {
            repayment.defaultInterestPlusTaxF5 &&
            <span className='icon icon-download g_m_left_50 g_cursor_pointer g_muted' onClick={onDownloadPenalChargeClick}
              data-scheduled-dateISO={repayment.scheduledDateISO} />
          }
        </div>
      }
    </td>

    <td className='g_text_right'>
      <span className='g_flex_v'>
        {
          repayment.defaultInterestPaidDateF1 &&
          <>
            <span>{repayment.defaultInterestF5}</span>
            <LabelAndValueUI label='Paid' className='g_tiny'>{repayment.defaultInterestPaidDateF1}</LabelAndValueUI>
          </>
        }
      </span>
    </td>
  </React.Fragment>

const ChargeUI = ({ chargeAmountsList, chargeType }) => {
  return (
    <React.Fragment>
      <td className='g_text_right'>
        {chargeAmountsList &&
          chargeAmountsList
            .filter((c) => c.chargeType === chargeType)
            .map((charge, i) => (
              <div className="g_info g_flex_v" key={i}>
                <span className='g_tiny'>{charge.dueDateF1}</span>
                <span>{charge.amountF4 || "N/A"}</span>
              </div>
            ))}
      </td>
    </React.Fragment>
  );
};

const PaymentUI = ({ }) => {
  return (
    <React.Fragment>
      <td className='g_text_right'>
        {/*TODO*/}
      </td>
    </React.Fragment>
  );
};

export default RepaymentListUI
